import { useEffect } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import NavLinks from '../NavLinks';

import validate from './ClubRecognitionSearchValidation';

import useSecurityData from '@usas/ui-web/state/security/UseSecurityData';
import useEnvironmentVariableData from '@usas/ui-web/state/environmentVariable/UseEnvironmentVariableData';
import useSelectOrgUnitData from '@usas/ui-web/state/selectOrgUnit/UseSelectOrgUnitData';
import UseForm from '@usas/ui-web/utils/UseForm';

import Constants from '@usas/ui-web/utils/Constants';

const TAXONOMIES = [''];
const SCOPE = 'ClubRecognition';

const useClubRecognitionSearch = () => {
  const navigate = useNavigate();
  const { getContextSecurity } = useSecurityData();
  const { environmentVariableState, USAS_ORGANIZATION_ID } = useEnvironmentVariableData();
  const { selectOrgUnitState, setSelectOrgUnitState } = useSelectOrgUnitData();
  const { formState, errorState, handleSubmit, setFormState, onValueTextPairChanged, isDirty
  } = UseForm(getInitialFormState(), submitFormCallback, validate);

  function submitFormCallback() {
    setSelectOrgUnitState({
      ...selectOrgUnitState,
      orgUnitId: formState.orgUnitId,
      orgUnitName: formState.orgUnitName,
      showBackToSelection: false
    });
    getContextSecurity(formState.orgUnitId, TAXONOMIES, SCOPE)
  };

  const clearForm = () => {
    setFormState(getInitialFormState());
  };

  useEffect(() => {
    if (selectOrgUnitState.orgUnitId === formState.orgUnitId
      && selectOrgUnitState.orgUnitName === formState.orgUnitName
      && isDirty === true) {
        navigate(NavLinks.CLUB_RECOGNITION_PROGRAM_LEVEL);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectOrgUnitState.orgUnitId, selectOrgUnitState.orgUnitName]);

  useEffect(() => {
    if (environmentVariableState.isLoaded === true) {
      if (formState.organizationId !== USAS_ORGANIZATION_ID) {
        setFormState({
          ...formState,
          organizationId: USAS_ORGANIZATION_ID,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [environmentVariableState.isLoaded, formState.organizationId]);

  return {
    formState,
    errorState,
    environmentVariableState,
    onValueTextPairChanged,
    clearForm,
    handleSubmit
  };
};

export default useClubRecognitionSearch;

function getInitialFormState() {
  return {
    organizationId: Constants.DEFAULT_ID,
    lscOrgUnitId: Constants.DEFAULT_ID,
    orgUnitId: '',
    orgUnitName: ''
  };
};